import { MODIFY_TITLE_FONT_SKU } from '@/constants/modify-title-font-sku';
import { websiteEnv } from '@/constants/website-env';
import clsx from 'clsx';

export const ProductTitle = ({ name, seoColorLabel, sku }: { name: string; seoColorLabel?: string; sku: string }) => {
  return (
    <>
      <h1
        aria-live='polite'
        className={clsx(
          'pr-7  text-2xl uppercase leading-7 lg_pr-0 lg_text-[28px] lg_leading-[34px] ',
          MODIFY_TITLE_FONT_SKU.includes(sku) ? 'font-jost' : 'font-Shango',
        )}
        dangerouslySetInnerHTML={{ __html: name }}
      />
      {seoColorLabel ? (
        <p className='text-[15px] capitalize leading-[1.4] text-BE9983 lg_text-[15px] lg_leading-4'>
          {websiteEnv.isUnitedKingdom && seoColorLabel === 'Multi Color' ? 'Multicolour' : seoColorLabel}
        </p>
      ) : null}
    </>
  );
};
